// in SignalRContext.js
import { createContext, useContext, useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";

const SignalRContext = createContext();

export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);

  const BASE_URL = process.env.REACT_APP_SIGNALR_URL;
  // const BASE_URL = "https://dev-api.debatebase.com/debateHub";
  // const BASE_URL = "http://192.168.29.250:7099/debateHub";
  // const initConnection = () => {
  //   const connection = new signalR.HubConnectionBuilder()
  //     .withUrl(BASE_URL, {
  //       withCredentials: false,
  //     })
  //     .withAutomaticReconnect() // built-in retry
  //     .configureLogging(signalR.LogLevel.Information)
  //     .build();
  //   setConnection(connection);

  //   connection.onreconnected(() => {
  //     const selectedWorkspace = localStorage?.getItem("selectedWorkspace");
  //     const parsedSelectedWorkspace =
  //       selectedWorkspace && selectedWorkspace !== "undefined"
  //         ? JSON?.parse(selectedWorkspace)
  //         : undefined;
  //     connection.invoke(
  //       "JoinWorkspaceGroup",
  //       parsedSelectedWorkspace?.workSpaceId
  //     );
  //     console.log("SignalR reconnected.");
  //   });

  //   connection.onclose(() => {
  //     console.log("SignalR connection closed.");
  //   });

  //   connection.onreconnecting(() => {
  //     console.log("SignalR reconnecting.");
  //   });

  //   return connection;
  // };

  const startConnection = async () => {
    if (!connection) {
      throw new Error("SignalR Connection not initialized!");
    }
    try {
      await connection.start();
      console.log("SignalR Connected.");
    } catch (err) {
      console.error("SignalR Connection Error: ", err);
      // you can retry here, or rely on withAutomaticReconnect
    }
  };

  const stopConnection = async () => {
    if (connection) {
      await connection.stop();
      console.log("SignalR Disconnected.");
    }
  };

  const onReceive = (methodName, callback) => {
    if (!connection) throw new Error("Connection not initialized!");
    connection.on(methodName, callback);
  };

  const offReceive = (methodName, callback) => {
    if (!connection) throw new Error("Connection not initialized!");
    connection.off(methodName, callback);
  };

  const sendMessage = async (methodName, ...args) => {
    if (!connection && connection.state !== "Connected")
      console.error("SignalR Connection not established!");
    return connection.invoke(methodName, ...args);
  };

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(BASE_URL, {
        withCredentials: false,
      })
      .withAutomaticReconnect() // built-in retry
      .configureLogging(signalR.LogLevel.Information)
      .build();

    setConnection(connection);
    if (!connection) {
      throw new Error("SignalR Connection not initialized!");
    }
    try {
      connection.start();
      console.log("SignalR Connected.");
    } catch (err) {
      console.error("SignalR Connection Error: ", err);
      // you can retry here, or rely on withAutomaticReconnect
    }

    return () => {
      stopConnection();
    };
  }, []);

  return (
    <SignalRContext.Provider
      value={{
        connection,
        startConnection,
        stopConnection,
        onReceive,
        offReceive,
        sendMessage,
      }}
    >
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);
